import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';

/**
 * Deactivate the current organisation.
 *   POST /api/Organization/{orgId}:DeActivate
 *
 * Flutter uses GET for this in `settings_data_source_impl.dart:440-446` which
 * is semantically odd for a state mutation — switched to POST here. If the
 * backend rejects POST, fall back to GET to match Flutter exactly.
 */
export function useDeactivateOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (orgId: string) =>
      post<unknown>(`/api/Organization/${orgId}:DeActivate`, {}),
    onSuccess: (_data, orgId) => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'organization', orgId] });
    },
  });
}
